<template>
  <div class="menu" v-on:click.prevent="active = !active">
    <div
      class="hamburger"
      v-bind:class="{ [style]: true, 'is-active': active }"
    >
      <div class="hamburger-box">
        <div class="hamburger-inner"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { scroll } from "../../mixins/index";

export default {
  data() {
    return {
      active: false,
      style: "hamburger--spring",
    };
  },
  mixins: [scroll],
  watch: {
    active(val) {
      bus.$emit("hamburger:active", val);

      if (val) {
        this.scroll({
          to: "html",
          duration: 1,
        });
      }
    },
  },
  created() {
    bus.$on("hamburger:active", (val) => {
      this.active = val;
    });
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";

/* hamburgers
   npm install --save hamburgers
   https://jonsuh.com/hamburgers/#customization
--------------------------------------------- */
$hamburger-padding-x: 0;
$hamburger-padding-y: 16px;
$hamburger-layer-width: 22px;
$hamburger-layer-height: 2px;
$hamburger-layer-spacing: 4px;

$hamburger-layer-color: $cc-resmed-white;
$hamburger-layer-border-radius: 0;
$hamburger-hover-opacity: 0.7;
$hamburger-hover-transition-duration: 200ms;
@import "node_modules/hamburgers/_sass/hamburgers/hamburgers";

.hamburger {
  display: flex;
}
</style>
